import Vue from "vue";
import i18n from "@/plugins/i18n/translations";

let min;
let max;

const validations = {
	required: {
		rule: (value) => {
			if (value != undefined && value != null && value != "") {
				if (typeof value === "string" && value.trim() === "") return false;
				return true;
			}
			return false;
		},
		message: i18n.t("messages.fieldIsMandatory")
	},
	requiredAlternative: {
		rule: (alternative) => {
			let result = Object.keys(alternative).length > 0;
			Object.values(alternative).forEach((option) => {
				let value = option.description;
				result = result && value != "" && value != undefined && value != null;
			});
			return result;
		},
		message: i18n.t("messages.fieldMustHaveAtLeastAnOption")
	},
	attention: {
		rule: (value) => {
			if (value != "" && value != undefined && value != null) return true;
			return false;
		}
	},
	emailNotRequired: {
		rule: (value) => {
			if (value != "" && value != undefined && value != null) return validateEmail(value);
			return true;
		},
		message: i18n.t("messages.mailNotValid")
	},
	email: {
		rule: (value) => validateEmail(value),
		message: i18n.t("messages.mailNotValid")
	},
	radioButton: {
		rule: (value) => {
			return value != null;
		},
		message: i18n.t("messages.selectAnOption")
	},
	cpf: {
		rule: (value) => {
			return Vue.prototype.$functions.validateCpf(value);
		},
		message: i18n.t("messages.cpfNotValid")
	},
	cnpj: {
		rule: (value) => {
			return Vue.prototype.$functions.validateCnpj(value);
		},
		message: i18n.t("messages.cnpjNotValid")
	},
	cpfCnpj: {
		rule: (value) => {
			return Vue.prototype.$functions.validateCpfCnpj(value);
		},
		message: i18n.t("messages.cpfCnpjNotValid")
	},
	password: {
		rule: (value) => {
			if (typeof value !== "string") return false;
			if (value.length < 12) return false;
			if (value.length > 16) return false;
			if (!/[!@#$%^&*(),.?":{}|<>_\-\\[\]=+~;`'/]/.test(value)) return false;
			if (!/\d/.test(value)) return false;
			if (!/[A-Z]/.test(value)) return false;
			return true;
		},
		message: i18n.t("messages.passwordRules")
	},
	passwordStrong: {
		rule: (value) => {
			if (typeof value !== "string") return false;
			if (value.length < 12) return false;
			if (value.length > 16) return false;
			if (!/[!@#$%^&*(),.?":{}|<>_\-\\[\]=+~;`'/]/.test(value)) return false;
			if (!/\d/.test(value)) return false;
			if (!/[A-Z]/.test(value)) return false;
			return true;
		}
	},
	number: {
		rule: (value) => {
			if (typeof value == Number && value.toString().includes(".")) return false;
			if (typeof value == Number && value.toString().includes(",")) return false;
			if (typeof value == String && value.includes(".")) return false;
			if (typeof value == String && value.includes(",")) return false;
			if (value < min || value > max || value === "") return false;

			return true;
		}
	},
	months: {
		rule: (value) => {
			return value >= 1 && value <= 60;
		},
		message: i18n.t("messages.monthQuantityInvalid")
	},
	hour: {
		rule: (value) => {
			value = /^(([01][0-9]|2[0-3])h)|(([01][0-9]|2[0-3]):[0-5][0-9])$/.test(value) ? value : "";
			if (value == "") {
				return false;
			} else {
				return true;
			}
		},
		message: i18n.t("messages.hourInvalid")
	},
	birthDateRequired: {
		rule: (value) => validateDateOfBirth(value, true),
		message: i18n.t("messages.birthDateInvalid")
	},
	birthDateNotRequired: {
		rule: (value) => validateDateOfBirth(value, false),
		message: i18n.t("messages.birthDateInvalid")
	},
	dateValidateNotRequired: {
		rule: (value) => {
			return validateDate(value);
		},
		message: i18n.t("messages.dateInputInvalid")
	},
	dateValidateRequired: {
		rule: (value) => {
			if (value != "" && value != undefined && value != null) return validateDate(value);
			else return false;
		},
		message: i18n.t("messages.dateInvalid")
	},
	requirementFinalDateValidate(initialDate) {
		return {
			rule: (value) => {
				if (!value) return false;
				var formatedInitialDate = parseDate(initialDate).getTime();
				var formatedEndDate = parseDate(value).getTime();
				if (formatedEndDate < formatedInitialDate) {
					return false;
				} else if (value != "" && value != undefined && value != null && formatedEndDate > formatedInitialDate) {
					return validateDate(value);
				}
			},
			message: i18n.t("messages.invalidDateOrEndDateMustBeAfterStartDate")
		};
	},
	specialCharacters: {
		rule: (value) => {
			const specialChars = /[ `!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]/;
			if (value === null || value === undefined || value === "" || (typeof value === "string" && value.trim() === "")) {
				return true;
			}
			if (specialChars.test(value) || value.length > 25) {
				return false;
			} else {
				return true;
			}
		},
		message: i18n.t("messages.checkCharacterLimit25")
	},
	specialCharactersIgnore: {
		rule: (value) => Vue.prototype.$functions.checkChar(value)
	},
	description(maxLenght) {
		let textLimit = maxLenght;
		return {
			rule: (value) => {
				if (value != "" && value != undefined && value != null) {
					if (value.length <= textLimit) return true;
				}
				return false;
			},
			message: i18n.t("messages.mandatoryFieldWithCharLimit", [textLimit])
		};
	},
	minOverMax(min, max) {
		return {
			rule: () => {
				return Vue.prototype.$functions.validateMinMaxLenght(min, max);
			},
			message: "O valor mínimo não pode ser maior que o máximo."
		};
	},
	minMaxLength(min, max) {
		return {
			rule: () => {
				return Vue.prototype.$functions.validateMinMaxLenght(min, max);
			},
			message: `Você não pode digitar um valor menor que 0 e maior que 4000.`
		};
	},
	minMaxNotRequired(min, max) {
		return {
			rule: (value) => {
				if (value != "" && value != undefined && value != null)
					return Vue.prototype.$functions.validateMinMax(value, min, max);
				return true;
			},
			message: `Você não pode digitar um valor menor que ${min} e maior que ${max}.`
		};
	},
	minMax(min, max) {
		return {
			rule: (value) => {
				if (value) return Vue.prototype.$functions.validateMinMax(value, min, max);
				return false;
			},
			message: `Você não pode digitar um valor menor que ${min} e maior que ${max}.`
		};
	},
	userName: {
		rule: (value) => validateUserName(value),
		message: i18n.t("messages.userInputNotValid")
	},
	decimal: {
		rule: (value) => {
			if (!value) return false;

			return Vue.prototype.$functions.validateDecimal(value);
		},
		message: i18n.t("messages.decimalInputNotValid")
	},
	moneyCurrency: {
		rule: (value) => {
			if (!value) return false;

			return Vue.prototype.$functions.validateCurrency(value);
		},
		message: i18n.t("messages.monetaryInputNotValid")
	},
	licensePlate: {
		rule: (value) => {
			if (value != "" && value != undefined && value != null) return true;

			return false;
		},
		message: i18n.t("messages.vehicleLicensePlateIsMandatory")
	}
};

function setMinMax(minInput, maxInput) {
	min = minInput;
	max = maxInput;
	validations.number.message = i18n.t("messages.integerBetweenMinMax", [min, max]);
}

function validateEmail(email) {
	const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
	return re.test(String(email).toLowerCase());
}

function validateUserName(username) {
	const regexp = /^\S*$/;
	const specialChars = /[ `!@#$%^&*()_+\-=[\]{};':"\\|,<>/?~]/;
	return regexp.test(String(username).toLowerCase()) && !specialChars.test(String(username).toLowerCase());
}

function validateDate(date) {
	if (!date) return true;

	var length = date.length;
	var j = 0;
	var dt = { 0: "", 1: "", 2: "" };
	var monthDays = [0, 31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

	for (var i = 0; i < length; i++) {
		var c = date[i];
		if (c !== "/") dt[j] += c;
		else j++;
	}
	var d = +dt[0];
	var m = +dt[1];
	var y = +dt[2];

	// atualiza dias do ano bisexto
	monthDays[2] += +(y % 400 === 0 || (y % 4 === 0 && y % 100 !== 0));
	if (date == "") {
		return true;
	}
	if (m < 1 || m > 12 || d < 1) {
		return false;
	} else if (d > monthDays[m]) {
		return false;
	} else if (y < 1900) {
		return false;
	}
	return true;
}

function parseDate(str) {
	const parts = str.split("/");
	return new Date(parts[2], parts[1] - 1, parts[0]);
}

function validateDateOfBirth(value, required) {
	if (!value) return !required;
	if (!validateDate(value)) return false;

	const birthDate = parseDate(value);

	if (isNaN(birthDate.getTime())) return false;

	const currentDate = new Date();
	currentDate.setHours(23, 59, 59, 999);

	if (birthDate > currentDate) return false;

	const minYear = 1900;
	if (birthDate.getFullYear() < minYear) return false;

	const maxAge = 150;
	const minBirthDate = new Date();
	minBirthDate.setFullYear(minBirthDate.getFullYear() - maxAge);

	if (birthDate < minBirthDate) return false;

	return true;
}

Vue.use({
	install(Vue) {
		Vue.prototype.$validations = validations;
		Vue.prototype.$setMinMax = setMinMax;
		Vue.prototype.$validateEmail = validateEmail;
	}
});

export default validations;
